import {Component, OnInit, signal, viewChild} from '@angular/core';
import {CalendrierComponent} from '../shared/components/calendrier/calendrier.component';
import {StorageService} from '../shared/services/storage.service';
import {PlageSelectionnee} from '../shared/models/plage-selectionnee.model';
import {UtilisateurSigalettService} from '../shared/services/utilisateur-sigalett.service';
import {AuthService} from '../shared/services/auth-service.service';

@Component({
	selector: 'app-accueil',
	templateUrl: './accueil.component.html',
	styleUrl: './accueil.component.scss'
})
export class AccueilComponent implements OnInit {
	readonly NOM_ALERTE_ERREUR_GENERALE = 'visualisationEvenements';

	calendrierComponent = viewChild(CalendrierComponent);

	plagesSelectionnees = signal<PlageSelectionnee[]>([]);
	masquerReservations = signal(false);
	afficherWeekend = signal(false);

	constructor(private storageService: StorageService, private utilisateurSigalettService: UtilisateurSigalettService, private authService: AuthService) {
	}

	ngOnInit() {
		const masquerReservations = this.storageService.estMasquerReservationsDeBureau();
		this.masquerReservations.set(masquerReservations);

		this.utilisateurSigalettService.rechercherPreferencesUtilisateur(this.authService.getUtilisateurConnecte().login)
			.subscribe({
				next: preferencesUtilisateurDto => {
					this.afficherWeekend.set(preferencesUtilisateurDto.afficherWeekend);
				},
				error: () => {
					// tant pis
				}
			});
	}

	/**
	 * Recharge le calendrier avec les nouveaux évènements fraichement créés.
	 */
	onCreationEvenements(): void {
		this.calendrierComponent().rechargerCalendrier();
	}

	onChangeMasquerReservations(event: any): void {
		this.storageService.setMasquerReservationsDeBureau(event.checked);
	}
}
